import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HomeService } from 'src/app/pages/home/services/home.service';

@Component({
  selector: 'app-hotlist-modal',
  templateUrl: './hotlist-modal.component.html',
  styleUrls: ['./hotlist-modal.component.css']
})
export class HotlistModalComponent {
  @Input() data: any[];

  constructor(public activeModal: NgbActiveModal, public homeService : HomeService) { }

  updateHotlistItem (module) {
    this.homeService.setHotlistItem(module).then((response:any) =>{
   });
  }

  closeClicked() {
    this.activeModal.close('close');
  }

  keepOriginalOrder(){
    return 0;
  }
}
